import * as constants from './constants';

const updatePointOfInterestLaunched = id => {
  return {
    type: constants.UPDATE_POI_LAUNCHED,
    id
  };
};

const updatePointOfInterestSuccess = pointOfInterest => {
  return {
    type: constants.UPDATE_POI_SUCCESS,
    pointOfInterest
  };
};

const updatePointOfInterestFailure = errors => {
  return {
    type: constants.UPDATE_POI_FAILURE,
    errors
  };
};

const setMapFullWidth = isClicked => {
  return {
    type: constants.SET_MAP_FULL_WIDTH,
    isClicked
  };
};

export { updatePointOfInterestFailure, updatePointOfInterestSuccess, updatePointOfInterestLaunched, setMapFullWidth };
